import {CircularProgress} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import {FC} from "react";

interface IProps {
    counter: number
    seconds: number
    buttonLabel: string
    handleOnSubmitClick: () => void
    color: 'primary' | 'secondary'
    disabled?: boolean
}

const ButtonWithProgress: FC<IProps> = (props) => {
    const calculateProgress = Math.floor((props.counter / props.seconds) * 100)

    return (
        <LoadingButton variant='contained'
                       color={props.color}
                       loading={!!props.counter}
                       sx={{
                           "& .MuiLoadingButton-loadingIndicator": {
                               right: '50%',
                               transform: "translateX(50%)"
                           }
                       }}
                       disabled={!!props.disabled}
                       onClick={props.handleOnSubmitClick}
                       loadingIndicator={<CircularProgress size='25px'
                                                           variant='determinate'
                                                           value={calculateProgress}/>}
                       loadingPosition='end'>{props.buttonLabel}</LoadingButton>
    )
}

export default ButtonWithProgress